import SpineSymbolBehaviour from "slotworks/components/matrix/symbol/behaviours/spine-symbol-behaviour";
import Contract from "slotworks/utils/contract";
import HarleySpineSymbolBehaviour from "./spine-symbol-behaviour";

export default class HarleyLandSpineSymbolBehaviour extends HarleySpineSymbolBehaviour {

    public land(...args: any[]): Contract<void> {
        return this.animate("land", true, false, undefined, undefined, 0.6);
    }

    public highlight(): Contract<void> {
        return Contract.empty();
    }

    public win(): Contract<void> {
        return Contract.empty();
    }

    public cycle(): Contract<void> {
        return Contract.empty();
    }
}